import queryString from 'query-string';
import React, { memo, PropsWithChildren, useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface ABTest {
  isA: () => boolean;
  isB: () => boolean;
}

class ABTestImpl implements ABTest {
  private _isA;

  constructor(isA) {
    this._isA = isA;
  }

  public isA() {
    return this._isA();
  }

  public isB() {
    return !this._isA();
  }
}

class ExperimentsImpl {
  public constructor() {
    const locationSearch = queryString.parse(useLocation().search);
    if (locationSearch.version) {
      console.log(`Setting version to ${locationSearch.version} via query string.`);
      this.setSiteVersion(locationSearch.version as any);
    }
  }

  public getSiteVersion(): ABTest {
    return new ABTestImpl(() => localStorage.getItem('homepage.version') === 'V1' || sessionStorage.getItem('homepage.version') === 'V1');
  }

  public setSiteVersion(version: 'V1' | 'V2') {
    sessionStorage.setItem('homepage.version', version);
  }
}

export const ExperimentsContext = React.createContext<ExperimentsImpl>(null);

export const Experiments = memo(function Experiments({ children }: PropsWithChildren<object>) {
  return <ExperimentsContext.Provider value={new ExperimentsImpl()}>{children}</ExperimentsContext.Provider>;
});

export const useExperiments = () => useContext(ExperimentsContext);
